import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import EducationImage from '@components/atoms/education/image/educationImage';
import EducationTime from '@components/atoms/education/time/educationTime';
import StyledEducationStage from './educationStage.style';

import Breadcrumb from '../../../molecules/breadcrumb/breadcrumb';
import Headline from '../../../atoms/headline/headline';
import MixedCopy from '../../../molecules/mixed-copy/mixedCopy';
import Container from '../../../layout/container/container';
import FilterTag from '../../../atoms/filter-tag/filterTag';
import EducationContentType from '../../../molecules/education/content-type/educationContentType';

function EducationStage({
  headline,
  introCopy,
  breadcrumb,
  titleImage,
  educationTopics,
  duration,
  educationType
}) {
  return (
    <StyledEducationStage>
      {breadcrumb && <Breadcrumb className="stage__breadcrumb" entries={breadcrumb} />}
      <Container large>
        <div className="stage__tag-line hidden-desktop">
          {educationTopics &&
            educationTopics.length < 7 &&
            educationTopics.map(item => (
              <FilterTag key={item.id} className="stage__tag" inverted>
                {item.title}
              </FilterTag>
            ))}
          <EducationTime value={duration} />
        </div>
        <div className="stage__grid">
          <EducationImage
            className="stage__image"
            titleClass="stage__image-title"
            image={titleImage}
            category={educationTopics}
            contentType={educationType}
          />
          <div className="stage__intro">
            <div className="stage__tag-line hidden-mobile">
              {educationTopics &&
                educationTopics.length < 7 &&
                educationTopics.map(item => (
                  <FilterTag key={item.id} className="stage__tag" inverted>
                    {item.title}
                  </FilterTag>
                ))}
              <EducationContentType contentType={educationType} />
            </div>
            {headline && <Headline tag="h1">{headline}</Headline>}
            {introCopy && <MixedCopy fullWidth html={introCopy} className="stage__introduction" />}
          </div>
        </div>
      </Container>
    </StyledEducationStage>
  );
}

EducationStage.propTypes = {
  headline: PropTypes.string,
  introCopy: PropTypes.string,
  duration: PropTypes.number,
  titleImage: PropTypes.shape({
    src: PropTypes.string,
    title: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  educationType: PropTypes.arrayOf(PropTypes.shape()),
  educationTopics: PropTypes.arrayOf(PropTypes.shape()),
  breadcrumb: PropTypes.arrayOf(PropTypes.shape())
};

const mapStateToProps = state => ({
  headline: state.app.pageData.headline,
  introCopy: state.app.pageData.introCopy,
  titleImage: state.app.pageData.titleImage,
  duration: state.app.pageData.duration,
  educationTopics: state.app.pageData.educationTopics,
  educationType: state.app.pageData.educationType,
  breadcrumb: state.app.pageData.breadcrumb
});

export default connect(mapStateToProps)(EducationStage);
